import {MS_IN_DAY} from 'shared/const';
import {getCurrentTime} from '../getCurrentTime';

export function getTodayStartTime(): DayStartTimeStamp {
  const currentTime: UnixTimeStamp = getCurrentTime();
  return new Date(currentTime).setHours(0, 0, 0, 0);
}

export function getTomorrowStartTime(): DayStartTimeStamp {
  return getTodayStartTime() + MS_IN_DAY;
}
